import React from 'react';
import { Modal, type ModalProps } from './Modal';
import { Button } from '../Button';

export interface ConfirmModalProps extends Omit<ModalProps, 'children'> {
  title: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: 'default' | 'danger' | 'success' | 'warning';
  onConfirm: () => void;
  onCancel?: () => void;
  loading?: boolean;
}

export const ConfirmModal = React.forwardRef<HTMLDivElement, ConfirmModalProps>(
  ({
    title,
    message,
    confirmText = '확인',
    cancelText = '취소',
    confirmVariant = 'default',
    onConfirm,
    onCancel,
    onClose,
    loading = false,
    ...modalProps
  }, ref) => {
    const handleCancel = () => {
      if (onCancel) {
        onCancel();
      } else {
        onClose();
      }
    };

    const handleConfirm = () => {
      onConfirm();
    };

    return (
      <Modal
        ref={ref}
        onClose={onClose}
        size="sm"
        {...modalProps}
      >
        <div className="p-6">
          <div className="mb-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {title}
            </h3>
            {message && (
              <p className="text-sm text-gray-600">
                {message}
              </p>
            )}
          </div>
          
          <div className="flex justify-end gap-3">
            <Button
              variant="outline"
              onClick={handleCancel}
              disabled={loading}
            >
              {cancelText}
            </Button>
            <Button
              variant={confirmVariant}
              onClick={handleConfirm}
              loading={loading}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
);

ConfirmModal.displayName = 'ConfirmModal';